// extracted by mini-css-extract-plugin
export default {"plan":"PlanItem_plan__I7X1-"};